// Redux Utils
import { useSelector, useDispatch } from "react-redux";
import { getUserInfo } from "@/features/user/userThunks";

// React and Libraries
import React, { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faBell,
  faCamera,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useLocation } from "react-router-dom";

// Thunks
import { updateImgPortada } from "@/features/user/userThunks";
import { updateImgPortadaEmpresa, getEmpresaInfo } from "@/features/empresa/empresaThunks";

// Components
import NotificationToast from "@/components/NotificationToast";

// Hooks
import useNotification from "@/hooks/useNotification";

export default function Portada({ info }) {
  // Router
  const location = useLocation();
  console.log("Location in Portada:", location);
  const navigate = useNavigate();
  // Redux
  const { user, isAuthenticated, isLoading } = useSelector(
    (state) => state.auth
  );
  const dispatch = useDispatch();

  // Detectar si es perfil de empresa
  const isEmpresaProfile = location.pathname.includes("/empresa/");

  const fileInputRef = useRef(null);
  const [uploadingImage, setUploadingImage] = useState(false);
  const { notification, showNotification, hideNotification } =
    useNotification();

  // Manejar click en el icono de cámara
  const handleCameraClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // Manejar selección de archivo
  const handleFileSelect = async (event) => {
    const file = event.target.files[0];

    if (!file) return;

    // Validar tipo de archivo
    if (!file.type.startsWith("image/")) {
      showNotification("Por favor selecciona una imagen válida", "error");
      return;
    }

    // Validar tamaño (5MB máximo)
    if (file.size > 5 * 1024 * 1024) {
      showNotification("La imagen no debe superar 5MB", "error");
      return;
    }

    try {
      setUploadingImage(true);

      if (isEmpresaProfile) {
        // Actualizar imagen de portada de empresa
        await dispatch(
          updateImgPortadaEmpresa({
            empresaUid: info.uid,
            imageFile: file,
          })
        ).unwrap();
      } else {
        // Actualizar imagen de portada de usuario
        await dispatch(
          updateImgPortada({
            userId: user.id,
            imageFile: file,
          })
        ).unwrap();
      }

      // Limpiar el input
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      // Mostrar notificación de éxito
      showNotification(
        "¡Imagen de portada actualizada exitosamente!",
        "success"
      );
    } catch (error) {
      console.error("Error al actualizar imagen de portada:", error);
      showNotification("Error al actualizar la imagen de portada", "error");
    } finally {
      setUploadingImage(false);
    }
  };

  return (
    <>
      {/* Notificación Toast */}
      <NotificationToast
        notification={notification}
        onClose={hideNotification}
      />

      <div className="w-full h-40 sm:h-60 md:h-72 lg:h-80 rounded-b-3xl overflow-hidden relative flex items-center justify-center group">
        {info.imgPortada != null ? (
          <img
            src={info.imgPortada}
            alt="Portada"
            className="w-full h-full object-cover bg-aw-bluegray"
          />
        ) : (
          <div className="w-full h-full flex justify-center items-center object-cover bg-aw-bluegray">
            <FontAwesomeIcon
              icon={"fa-solid fa-image"}
              className="text-white text-6xl opacity-20"
            />
          </div>
        )}

        {/* Overlay para el hover con icono de cámara - Solo si está autenticado y es mi perfil */}
        {isAuthenticated && user && info?.myself && (
          <>
            <div className="absolute inset-0  group-hover:hover:bg-aw-bluedark/15 transition-opacity duration-200 flex items-end justify-end p-4">
              <button
                onClick={handleCameraClick}
                disabled={uploadingImage || isLoading}
                className={`group/btn w-10 h-10 bg-aw-bluedark/80 rounded-full border-3 border-white shadow-lg flex items-center justify-center transition-all duration-200 opacity-65 group-hover:opacity-100 hover:bg-aw-green/85 hover:scale-105 ${
                  uploadingImage || isLoading
                    ? "opacity-50 cursor-not-allowed"
                    : "cursor-pointer"
                }`}
                title="Cambiar imagen de portada"
              >
                {uploadingImage || isLoading ? (
                  <FontAwesomeIcon
                    icon={"fa-solid fa-spinner"}
                    className="text-white text-xl fa-spin"
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={faCamera}
                    className="text-white group-hover/btn:text-aw-bluedark text-base"
                  />
                )}
              </button>
            </div>

            {/* Input de archivo oculto */}
            <input
              ref={fileInputRef}
              type="file"
              accept="image/jpeg,image/png,image/gif,image/webp"
              onChange={handleFileSelect}
              className="hidden"
            />
          </>
        )}

        {/* Botón atrás */}
        <button
          onClick={
            // ir a mi perfil
            () => {
              if (location.pathname.includes("/perfil/")) {
                navigate("/");
              }
              if (location.pathname.includes("/empresa/")) {
                window.location.href = `/perfil/${user?.uid}`;
              }
            }
          }
          className="absolute top-3 left-3 bg-aw-green rounded-full w-8 h-8 flex items-center justify-center text-aw-bluedark text-xl shadow-md z-10"
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
        {/* Bell icon */}
        {/* <button className="absolute top-3 right-3 bg-aw-bluedark-50 rounded-full w-8 h-8 flex items-center justify-center text-aw-green text-xl shadow-md z-10">
          <FontAwesomeIcon icon={faBell} />
        </button> */}
      </div>
    </>
  );
}
